// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n-action-config {
  cursor: pointer;
  color: var(--color-accent-subtle-base);
}
.n-action-config__toggle--pressed {
  color: var(--color-accent-subtle-contrast);
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/actions/ConfigAction/ConfigAction.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,sCAAA;AACF;AACE;EACE,0CAAA;AACJ","sourcesContent":[".n-action-config {\n  cursor: pointer;\n  color: var(--color-accent-subtle-base);\n\n  &__toggle--pressed {\n    color: var(--color-accent-subtle-contrast);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
